import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useState } from 'react';

const insertIntoString = (strOrigin, idx, removeCount, str) => {
  return strOrigin.slice(0, idx) + str + strOrigin.slice(idx + Math.abs(removeCount));
};

const ipRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

const digitOrDotRegex = /^[\d.]*$/;

const IpsInput = ({ id, name, values = [], onChange = () => {} }) => {
  const [ips, setIps] = useState(values || []);

  const [ip, setIp] = useState('');

  const handleChangeText = (e) => {
    if (!e) {
      return;
    }

    const {
      target: { value },
    } = e;

    if (!value) {
      setIps([]);
      setIp('');
      return;
    }

    const octets = value.split('.');

    let newIp = value;

    if (!digitOrDotRegex.test(value)) {
      return;
    }

    if (octets.length > 4) {
      return;
    }
    if (octets.length === 4 && octets[3].length > 3) {
      return;
    }
    if (octets[octets.length - 1].length > 3) {
      const head = octets.slice(0, octets.length - 1);
      const tail = octets[octets.length - 1];

      const headLength = head.length;

      newIp = `${head.join('.')}${headLength ? '.' : ''}${insertIntoString(tail, 3, 0, '.')}`;
    }

    setIp(newIp);

    if (ipRegex.test(newIp)) {
      setIps([newIp]);
    }
  };

  const handleChangeIps = (e, values) => {
    if (e.target.value) {
      setIp('');
    }

    onChange({ target: { id, value: values } });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (ipRegex.test(ip)) {
        onChange({ target: { id, value: [...values, ip] } });
        setIp('');
      }
      // não disparar submit quando apertar o enter
      e.stopPropagation();
      e.preventDefault();
    }
  };

  return (
    <>
      <Autocomplete
        multiple
        id={id}
        name={name}
        options={[...values, ...ips]}
        value={values}
        getOptionLabel={(option) => option}
        filterSelectedOptions
        inputValue={ip}
        onChange={handleChangeIps}
        onInputChange={handleChangeText}
        onKeyPress={handleKeyPress}
        noOptionsText="Digite um IP válido e tecle Enter"
        autoHighlight
        autoSelect
        renderInput={(params) => (
          <TextField {...params} variant="outlined" label="Ip's válidos" InputLabelProps={{ shrink: true }} />
        )}
      />
    </>
  );
};

export default IpsInput;
